import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/containers/CaseStudiesPage.tsx");
